import { SVGProps } from 'react';
const SvgMenuDuoMd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 15h14M5 9h14"
    />
  </svg>
);
export default SvgMenuDuoMd;
